import React, {useEffect, useMemo, useRef, useState} from 'react';
import {Template} from "../../../../components/template/template.jsx";
import Button from "../../../../components/button/button.jsx";
import {FaEraser, FaPlus, FaSearch} from "react-icons/fa";
import {Card} from "../../../../components/card/card.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import aggridUtils from "../../../../utils/aggrid-utils.js";
import {AgGridReact} from "ag-grid-react";
import {navigateHook} from "../../../../hooks/use-navigate.js";
import {useQuery} from "@tanstack/react-query";
import natureService from "../../../../services/web/nature-service.js";
import {useGlobalKey} from "../../../../hooks/use-global-key.js";
const initialFilter = {
    name: "",
    alias: "",
}

const NatureList = () => {
    const navigate = navigateHook();

    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState(initialFilter)
    const [filter, setFilter] = useState({});
    const [nature, setNature] = useState([]);

    const gridRef = useRef(null);
    const theme = useMemo(() => {
        return aggridUtils.generalTheme();
    }, []);

    const { status } = useQuery({
        queryFn: () =>  natureService.list(filter).then(({data}) => {
            setNature(data.data)
            return []
        }),
        queryKey: ['nature', filter],
    });

    useEffect(() => {
        if (status === 'success') setIsLoading(false)
        else setIsLoading(true)
    }, [status]);

    const columnDefs = [
        {
            headerName: "Nome", field: "name", flex: 1,
            comparator: (a, b, nodeA, nodeB, isInverted) => {
                return aggridUtils.nullLastComparator(a, b, nodeA, nodeB, isInverted);
            }
        },
        {
            headerName: "Nome apresentável", field: "alias", flex: 1,
            comparator: (a, b, nodeA, nodeB, isInverted) => {
                return aggridUtils.nullLastComparator(a, b, nodeA, nodeB, isInverted);
            }
        }
    ];

    const onChange = ({target}) => {
        let {id, value} = target;

        setState(prev => ({...prev, [id]: value}));
    }

    const onRowClicked = ({event, data}) => {
        let urlDev = `/nature/form/${data.id}`;
        let isBlank = false;
        if (event.ctrlKey) isBlank = true

        navigate(urlDev, isBlank);
    }
    const apply = () => {
        gridRef.current?.api?.showLoadingOverlay();
        setFilter({
            name: state.name,
            alias: state.alias,
        })
    }

    const clearFilter = () => {
        setState(initialFilter);
        setFilter({});
    }

    const newNature = (isBlank = false) => {
        let urlDev = `/nature/form`;
        navigate(urlDev, isBlank);
    }

    const handleClick = (e) => {
        if (e.ctrlKey) {
            newNature(true)
            return;
        }

        newNature()
    }

    useGlobalKey("Enter", apply)
    useGlobalKey("Escape", clearFilter)
    return (
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>Naturezas de ocorrências</Template.Title>
                    <Button onClick={(e) => handleClick(e)}>
                        <FaPlus /> Adicionar natureza
                    </Button>
            </Template.Header>
            <Template.Body className="flex flex-col space-y-2">
                <Card>
                    <Card.Body>
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-6">
                                <InputForm id="name" value={state.name} onChange={onChange} label="Nome"/>
                            </div>
                            <div className="col-span-6 flex gap-4">
                                <InputForm classNameWrapper="w-full" id="alias" value={state.alias} onChange={onChange} label="Nome apresentável"/>
                                <div className={"flex gap-2"}>
                                    <Button title="Limpar" onClick={clearFilter} target={"primary-outline"}>
                                        <FaEraser />
                                    </Button>
                                    <Button title="Buscar" onClick={apply} >
                                        <FaSearch />
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Card.Body>
                </Card>

                <Card>
                    <Card.Body className="flex">
                        <div className="h-[calc(100vh-153px)] w-full">
                            <AgGridReact
                                ref={gridRef}
                                rowData={nature}
                                columnDefs={columnDefs}
                                pagination
                                paginationPageSize={100}
                                paginationPageSizeSelector={[20, 50, 100, 500]}
                                animateRows={false}
                                suppressCellFocus={true}
                                onRowClicked={onRowClicked}
                                gridOptions={{localeText: aggridUtils.localization()}}
                                theme={theme}
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    );
};

export default NatureList;